import { render } from "./AddPreLesson.vue?vue&type=template&id=28efb388&scoped=true"
import script from "./AddPreLesson.vue?vue&type=script&lang=js"
export * from "./AddPreLesson.vue?vue&type=script&lang=js"

import "./AddPreLesson.vue?vue&type=style&index=0&id=28efb388&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28efb388"]])

export default __exports__